import { ArrowRight, ArrowLeft, Check, ShieldCheck, Clock, Star, Phone, MessageCircle } from 'lucide-react';
import { bt } from '@/i18n/bookingI18n';

const HERO_IMG = "/generated/chauffeur-hero-door.jpg";

export function BookingHero({ lang = 'en' }) {
  return (
    <section data-testid="chauffeur-hero" className="relative overflow-hidden bg-[#121212] text-white">
      <img src={HERO_IMG} alt="Eurogulf Premium Chauffeur opening a car door in Dubai" className="absolute inset-0 h-full w-full object-cover object-[center_30%]" />
      <div className={`absolute inset-0 bg-gradient-to-r ${lang === 'ar' ? 'from-black/20 via-black/60 to-black/85' : 'from-black/85 via-black/60 to-black/20'}`} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <span className="chip-orange">{bt(lang, 'heroChip')}</span>
        <h1 className="mt-4 font-heading font-black text-3xl sm:text-5xl lg:text-6xl leading-[1.03] tracking-tight text-white max-w-3xl">{bt(lang, 'heroTitle')}</h1>
        <p className="mt-4 font-body text-base sm:text-lg text-white/80 max-w-xl">{bt(lang, 'heroSub')}</p>
        <div className="mt-7 flex flex-col sm:flex-row gap-3">
          <a href="https://wa.me/971800364" target="_blank" rel="noopener noreferrer" data-testid="chauffeur-hero-whatsapp" className="btn-primary !bg-[#25D366] hover:!bg-[#1EbE5b]"><MessageCircle className="w-4 h-4" /> {bt(lang, 'heroWhatsapp')}</a>
          <a href="tel:800364" data-testid="chauffeur-hero-call" className="btn-outline !border-white !text-white hover:!bg-white hover:!text-[#121212]"><Phone className="w-4 h-4" /> {bt(lang, 'heroCall')}</a>
        </div>
      </div>
    </section>
  );
}

export function WizardNav({ step, submitting, onBack, onNext, onSubmit, lang = 'en' }) {
  const isAr = lang === 'ar';
  const NextArrow = isAr ? ArrowLeft : ArrowRight;
  const BackArrow = isAr ? ArrowRight : ArrowLeft;
  return (
    <div className="flex items-center justify-between mt-10 sm:mt-14 max-w-2xl mx-auto">
      {step > 0 ? (
        <button type="button" data-testid="btn-prev-step" onClick={onBack} className="btn-ghost"><BackArrow className="w-4 h-4" /> {bt(lang, 'back')}</button>
      ) : <div />}
      {step < 3 ? (
        <button type="button" data-testid="btn-next-step" onClick={onNext} className="btn-primary">{bt(lang, 'continue')} <NextArrow className="w-4 h-4" /></button>
      ) : (
        <button type="button" data-testid="btn-submit-booking" onClick={onSubmit} disabled={submitting} className="btn-primary disabled:opacity-50">
          {submitting ? bt(lang, 'submitting') : bt(lang, 'confirmBooking')} {!submitting && <Check className="w-4 h-4" />}
        </button>
      )}
    </div>
  );
}

export function TrustBar({ lang = 'en' }) {
  const TRUST = [
    { icon: Clock, stat: "24/7", label: bt(lang, 'trustDispatch') },
    { icon: ShieldCheck, stat: "7", label: bt(lang, 'trustLicensed') },
    { icon: Star, stat: "500+", label: bt(lang, 'trustVehicles') },
    { icon: Check, stat: bt(lang, 'trustSince'), label: bt(lang, 'trustExpertise') },
  ];
  return (
    <section className="bg-white py-12 border-t border-black/5">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 sm:grid-cols-4 gap-6">
        {TRUST.map((item) => (
          <div key={item.label} className="flex items-center gap-3">
            <span className="grid h-10 w-10 place-items-center rounded-lg bg-[#FFF4ED] text-[#EE5A01] flex-shrink-0"><item.icon className="w-5 h-5" /></span>
            <div><p className="font-heading font-black text-lg text-[#121212] leading-none">{item.stat}</p><p className="mt-1 font-body text-xs text-[#666666]">{item.label}</p></div>
          </div>
        ))}
      </div>
    </section>
  );
}
